import { ViewShift } from '@xeetr/types/models'
import { getWeekdayString } from '@xeetr/types/utils'

import HeaderBadges from '../common/HeaderBadges'
import OrderButtons from '../common/OrderButtons'

import { Badge } from '@/components/ui/badge'

interface Props {
  shift: ViewShift
  shiftIndex: number
  shifts: ViewShift[]
  swapShift: (fromIndex: number, toIndex: number) => void
}

const ShiftHeader = ({ shift, shiftIndex, shifts, swapShift }: Props) => {
  const orderUp = () => {
    if (shiftIndex === 0) return
    swapShift(shiftIndex, shiftIndex - 1)
  }

  const orderDown = () => {
    if (shiftIndex === shifts.length - 1) return
    swapShift(shiftIndex, shiftIndex + 1)
  }

  return (
    <div className="flex w-full justify-between">
      <div className="ml-2 flex flex-col gap-1">
        <span className="text-2xl font-normal">{shift.name}</span>
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-center">
          <Badge variant={shift.active ? 'default' : 'destructive'}>
            {shift.active ? 'Aktiv' : 'Inaktiv'}
          </Badge>
          {shift.isHoliday ? (
            <Badge variant="secondary">Betriebsferien</Badge>
          ) : (
            <>
              <div className="flex flex-wrap gap-1">
                {shift.weekdays.map((w) => (
                  <Badge key={w} variant="outline">
                    {getWeekdayString(w)}
                  </Badge>
                ))}
              </div>
              <div className="flex flex-wrap gap-1">
                <HeaderBadges values={shift.rooms} />
              </div>
            </>
          )}
        </div>
      </div>
      <OrderButtons
        disabledUp={shiftIndex === 0}
        onUp={orderUp}
        disabledDown={shiftIndex === shifts.length - 1}
        onDown={orderDown}
      />
    </div>
  )
}

export default ShiftHeader
